import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Past giveaways',
    errorLoading: "Couldn't load past giveaways",
  },
  ru: {
    title: 'Прошедшие раздачи',
    errorLoading: 'Не получилось загрузить прошедшие раздачи',
  },
  uz: {
    title: 'Oʻtgan ulashishlar',
    errorLoading: 'Oʻtgan ulashishlarni yuklab boʻlmadi',
  },
  fa: {
    title: 'پخش‌های گذشته',
    errorLoading: 'پخش‌های گذشته بارگذاری نشد',
  },
  pt: {
    title: 'Sorteios anteriores',
    errorLoading: 'Não foi possível carregar os sorteios anteriores',
  },
  tr: {
    title: 'Geçmiş çekilişler',
    errorLoading: 'Geçmiş çekilişler yüklenemedi',
  },
});
